import { POST_PUBLIC } from "../api/api";

async function partner(param) {
  try {
    const res = await POST_PUBLIC("event/partnership", param);
    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
}
async function partnerHistory(param) {
  try {
    const res = await POST_PUBLIC("event/partnership/report", param);
    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export { partner, partnerHistory };
